import { Skeleton, Typography } from "@mui/material";
import { useGetDashboardAnalyticsQuery } from "@/app/features/analytics/analyticsApiSlice";
import DashboardTable from "@/components/dashboard-table";

const AnalyticsTable = ({ startDate, endDate, type, title, selectedState }) => {
  const { data, isLoading, error } = useGetDashboardAnalyticsQuery({
    eventType: type,
    startDate,
    endDate,
    state: selectedState === "All" ? "" : selectedState,
  });

  if (isLoading) {
    return (
      <Skeleton
        sx={{
          transform: "scale(1, 1.0)",
          transformOrigin: "0% 0%",
        }}
        width="100%"
        height="600px"
      />
    );
  }

  if (error) {
    return <Typography variant="h3">Something went wrong</Typography>;
  }

  return <DashboardTable sx={{}} type={type} list={data.data} title={title} />;
};

export default AnalyticsTable;
